import { AUTH_PATHS } from "../routes/index.js";

export const BLOCKED_REDIRECT_PREFIXES = Object.freeze([
  ...AUTH_PATHS,
  "/api",
  "/loginas",
  "/logout",
  "/signup",
  "/emaillogin",
  "/fastlogin",
  "/r",
  "/checkout/confirmed",
  "/~partytownproxy",
  "/public",
  "/shared",
  "/manifests",
  "/.well-known",
  "/socket.io",
]);

// The WHATWG URL parser silently drops tabs and newlines, so they are rejected before parsing.
const CONTROL_CHARACTER = /\p{Cc}/u;

const isRelativePath = (r) =>
  typeof r === "string" &&
  r.startsWith("/") &&
  !r.startsWith("//") &&
  !r.includes("\\") &&
  !CONTROL_CHARACTER.test(r);

const isBlocked = (pathname, blocked) => {
  const path = pathname.toLowerCase();

  return blocked.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
};

const resolvedPath = (r, { origin, blocked }) => {
  const url = new URL(r, origin);

  return url.origin === origin && !isBlocked(url.pathname, blocked)
    ? `${url.pathname}${url.search}${url.hash}`
    : null;
};

export const safeRedirectPath = (r, options) =>
  isRelativePath(r) ? resolvedPath(r, options) : null;
